import React, { useEffect, useState } from 'react';
import { useFirebase } from '../../context/FirebaseContext';
import { getVersionInfoV2NoAuth } from '../../api/system';
import packageJson from '../../../package.json';
import { AlphaBadge } from './index';
import { analytics } from '../../firebaseConfig';
import { logEvent } from 'firebase/analytics';

const Version = () => {
    const [backendVersion, setBackendVersion] = useState('Loading...');
    const { auth } = useFirebase();

    useEffect(() => {
        const fetchVersion = async () => {
            await getVersionInfoV2NoAuth((data) => {
                if (data && !data.error) {
                    setBackendVersion(data);
                    // Log version info view
                    logEvent(analytics, 'version_info_viewed', {
                        frontend_version: packageJson.version,
                        backend_version: data,
                        user_id: auth.currentUser?.uid || 'anonymous'
                    });
                } else {
                    setBackendVersion('Error loading version');
                }
            });
        };

        fetchVersion();
    }, [auth]);

    return (
        <div style={{ padding: '20px', maxWidth: '600px', margin: '0 auto' }}>
            <br />
            <br />
            <h2 style={{ marginBottom: '16px' }}>Version Information <AlphaBadge /></h2>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '12px',
                    padding: '14px 16px',
                    background: 'var(--bg-secondary)',
                    border: '1px solid var(--border-color)',
                    borderRadius: '8px',
                }}>
                    <div style={{
                        width: '36px', height: '36px', borderRadius: '8px',
                        background: 'rgba(33, 150, 243, 0.12)',
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        color: 'var(--accent-color, #2196f3)', flexShrink: 0,
                    }}>
                        <span role="img" aria-label="frontend" style={{ fontSize: '16px' }}>WEB</span>
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column', minWidth: 0 }}>
                        <span style={{ fontSize: '0.65rem', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.5px', color: 'var(--text-secondary)' }}>Frontend</span>
                        <span style={{ fontSize: '0.9rem', fontWeight: 500, color: 'var(--text-primary)', fontFamily: 'monospace' }}>{packageJson.version}</span>
                    </div>
                </div>
                <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '12px',
                    padding: '14px 16px',
                    background: 'var(--bg-secondary)',
                    border: '1px solid var(--border-color)',
                    borderRadius: '8px',
                }}>
                    <div style={{
                        width: '36px', height: '36px', borderRadius: '8px',
                        background: 'rgba(76, 175, 80, 0.12)',
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        color: 'var(--success-color, #4caf50)', flexShrink: 0,
                    }}>
                        <span role="img" aria-label="backend" style={{ fontSize: '16px' }}>API</span>
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column', minWidth: 0 }}>
                        <span style={{ fontSize: '0.65rem', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.5px', color: 'var(--text-secondary)' }}>Backend</span>
                        <span style={{ fontSize: '0.9rem', fontWeight: 500, color: 'var(--text-primary)', fontFamily: 'monospace' }}>{backendVersion}</span>
                    </div>
                </div>
                <p style={{ marginTop: '8px', color: 'var(--text-secondary, #666)', fontSize: '0.85em' }}>
                    This is an experimental alpha version. Features and functionality may change without notice.
                </p>
            </div>
        </div>
    );
}; 

export default Version; 